import Footer from "../components/common/footer";
import About from "../components/home/about";
import { Helmet } from "react-helmet";
import Offer from "../components/home/offer";
import Transform from "../components/home/transform";
import Cta from "../components/home/cta";
import Portfolio from "../components/home/portfolio";
import Faq from "../components/home/faq";
import Mission from "../components/home/mission";
import Tools from "../components/home/tools";
import HeroNew from "../components/home/heroNew";
import HeaderTwo from "../components/common/headerTwo";

function Home() {
  return (
    <>
      <Helmet>
        <title>
          Przygotowanie działek pod budowę, mulczowanie i zakładanie ogrodów | DRZEWUS Pomorskie
        </title>
        <meta
          name="title"
          content="Przygotowanie działek pod budowę, mulczowanie i zakładanie ogrodów | DRZEWUS Pomorskie"
        />
        <meta
          name="description"
          content="DRZEWUS wykonuje mulczowanie, karczowanie i oczyszczanie działek pod budowę oraz zakładanie ogrodów na terenie Gdańska, Gdyni, Wejherowa, Kartuz, Kaszub i województwa pomorskiego. Przygotowujemy teren pod inwestycje, domy i zieleń."
          key="desc"
        />
        <meta
          property="og:title"
          content="Przygotowanie działek pod budowę, mulczowanie i zakładanie ogrodów | DRZEWUS Pomorskie"
        />
        <meta
          property="og:description"
          content="DRZEWUS wykonuje mulczowanie, karczowanie i oczyszczanie działek pod budowę oraz zakładanie ogrodów na terenie Gdańska, Gdyni, Wejherowa, Kartuz, Kaszub i województwa pomorskiego. Przygotowujemy teren pod inwestycje, domy i zieleń."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <HeroNew />
        <About />
        <Offer />
        <Transform />
        <Cta />
        <Portfolio />
        <Mission />
        <Faq />
        <Tools />
      </main>
      <Footer />
    </>
  );
}
export default Home;
